export default {
    customer_details:{},
    userdata: {},
    status: {
        loading: false,
        error: null,
    },
};
